module.exports = __webpack_public_path__ + "static/media/logo-restyle.d6f476f7.svg";